import ReactGA from 'react-ga4';

export const trackEvent = (eventName: string, params?: Record<string, string | number | boolean>) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
  }

  ReactGA.event({
    category: params?.event_category?.toString() || 'Engagement',
    action: eventName,
    label: params?.event_label?.toString(),
    value: typeof params?.value === 'number' ? params.value : undefined
  });
};

export const trackCTAClick = (ctaName: string, location: string) => {
  trackEvent('cta_click', {
    cta_name: ctaName,
    location: location,
    event_category: 'CTA',
    event_label: `${ctaName} - ${location}`
  });
};

export const trackScrollDepth = (percent: number) => {
  trackEvent('scroll_depth', {
    percent: percent,
    event_category: 'Engagement',
    event_label: `${percent}%`
  });
};

declare global {
  interface Window {
    gtag: (command: 'event' | 'config' | 'js' | 'set', targetId: string, config?: Record<string, unknown>) => void;
  }
}
